module.exports = __webpack_public_path__ + "name=img/src/assets/projects/code/yandex-ok/3.png?75ec3656a5323bfe240cb29c81288eb9";